import { createFileRoute } from '@tanstack/react-router';

import { PersonTeam } from '~/features/workspace/person/person-team';

/** Everyone who reports to a person, however deep. */
export const Route = createFileRoute('/_app/business/people/$userId/team')({ component: PersonTeam });
